<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap">
      <!-- ▼未来契約 Container -->
      <section
        v-for="contract in futureContracts"
        :key="contract.id"
        class="boss-contractperiod-container"
        data-test="future-container"
      >
        <scout-top-contract-container :contract-id="contract.id" />
      </section>
      <!-- ▲未来契約 Container -->
      <!-- ▼掲載期間中 Container -->
      <section
        v-for="contract in publishedContracts"
        :key="contract.id"
        class="boss-contractperiod-container"
        data-test="published-container"
      >
        <scout-top-contract-container :contract-id="contract.id" />
      </section>
      <ul
        id="boss-layout boss-layout-gap-between"
        class="boss-button-list clearfix"
      >
        <li
          v-if="endContracts.length"
          class="float-left boss-button-item"
        >
          <button
            class="boss-button-dark-gray boss-true"
            data-test="button-end-contracts"
            @click="showEndContractCtl"
          >
            <div v-if="showEndContract">
              <span class="boss-button-before boss-icon-triangle-up" />
              <span>掲載終了した期間を閉じる</span>
            </div>
            <div v-else>
              <span class="boss-button-before boss-icon-triangle-down" />
              <span>掲載終了した期間を開く</span>
            </div>
          </button>
        </li>
        <li
          data-test="button-excluded"
          class="float-right boss-button-item boss-button-item-right"
          @click="$router.push('/scouts/excluded_members')"
        >
          <button
            v-tooltip="{ content: 'スカウトの送信対象から除外済みの会員です。'}"
            class="boss-button boss-button-exclude boss-bgcolor-secondary boss-color-white ture"
          >
            <span class="boss-button-before boss-icon-triangle" />
            <span class="boss-button-text">除外者一覧</span>
          </button>
        </li>
      </ul>
      <span v-show="showEndContract">
        <section
          v-for="contract in renderingEndContracts"
          :key="contract.id"
          class="boss-contractperiod-container"
          data-test="end-container"
        >
          <scout-top-contract-container :contract-id="contract.id" />
        </section>
        <div class="text-center">
          <button
            v-if="endContracts.length > renderingEndContracts.length"
            class="boss-button-center boss-button-large margin-top-1 margin-bottom-1"
            data-test="more-end-contract-button"
            @click="onMoreEndContractClick"
          >
            もっと見る
          </button>
        </div>
      </span>
      <div>
        <section class="boss-pickup-container">
          <scout-recommended-members />
        </section>
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import ScoutTopContractContainer from '@/components/organisms/ScoutTopContractContainer'
import ScoutRecommendedMembers from '@/components/organisms/ScoutRecommendedMembers'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: { ScoutTopContractContainer, ScoutRecommendedMembers },
  data () {
    return {
      contracts: [],
      showEndContract: false,
      renderingEndContracts: [],
      remainingEndContracts: []
    }
  },
  computed: {
    ...mapGetters('contracts', {
      futureContracts: 'futureContracts',
      publishedContracts: 'publishedContracts',
      endContracts: 'endContracts'
    })
  },
  watch: {
    endContracts (val) {
      if (!_.isEmpty(val)) {
        const cloneContracts = _.cloneDeep(val)
        this.$set(this, 'renderingEndContracts', [cloneContracts.shift()])
        this.$set(this, 'remainingEndContracts', cloneContracts)
      }
    }
  },
  created () {
    // storeのcontractsを空にすることでScoutTopContractContainerの描画を抑制し、処理順を固定。
    // この処理が無いと、既にstoreにcontractが保存されている場合にAPIのレスポンス速度次第で検索条件IDの保存が競合する。
    // 以下具体例
    // - storeContracts()の処理を終えるより先にScoutTopContractContainerが描画される
    // - ScoutTopContractContainer内で、setSearchConditionId()が実施され、先に処理が終わる
    // - storeContracts()の処理終わりで、contract.jobs.searchConditionIdが0で上書きされてしまう
    this.clearContracts()
    this.storeContracts()
  },
  methods: {
    showEndContractCtl () {
      this.$set(this, 'showEndContract', !this.showEndContract)
    },
    ...mapActions('contracts', [
      'storeContracts',
      'clearContracts'
    ]),
    onMoreEndContractClick () {
      this.renderingEndContracts.push(this.remainingEndContracts.shift())
    }
  }
}
</script>
